import { action, makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import type { StudentClassesDto } from '@/application/interfaces/pegasus.gateway';

@singleton()
export class StudentClassesStore {
  @observable currentStudentClass: StudentClassesDto;

  constructor() {
    makeObservable(this);
  }

  @action
  setCurrentStudentClass = (currentStudentClass: StudentClassesDto) => {
    this.currentStudentClass = currentStudentClass;
  };

  @action
  getCurrentStudentClass = (): StudentClassesDto => {
    return this.currentStudentClass;
  };

  @action
  getStudentClassesTrackingInfo = () => {
    return {
      studentClassGuid: this.currentStudentClass?.guid,
      studentClassTags: this.currentStudentClass?.tags,
      studentClassTitle: this.currentStudentClass?.title,
    };
  };
}
